import styled from 'styled-components';

interface IOptionalFrame {
	top?: number;
	right?: number;
	bottom?: number;
	left?: number;
}

export default styled.div<IOptionalFrame>`
	top: ${(props) => (props.top != null ? `${props.top}px` : 'unset')};
	right: ${(props) => (props.right != null ? `${props.right}px` : 'unset')};
	bottom: ${(props) => (props.bottom != null ? `${props.bottom}px` : 'unset')};
	left: ${(props) => (props.left != null ? `${props.left}px` : 'unset')};
	position: absolute;
`;
